

export class TooltipOptionInput implements ITooltipOptionInput {
    /** The auto-generated id of the customize tool tip  master */
    tooltipOptionId!: number;

    constructor(data?: ITooltipOptionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tooltipOptionId = _data["tooltipOptionId"];
        }
    }

    static fromJS(data: any): TooltipOptionInput {
        data = typeof data === 'object' ? data : {};
        let result = new TooltipOptionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tooltipOptionId"] = this.tooltipOptionId;
        return data; 
    }
}

export interface ITooltipOptionInput {
    /** The auto-generated id of the customize tool tip  master */
    tooltipOptionId: number;
}

